import type { FC, PropsWithChildren } from "react";
import { rightPanel, rightPanelImg, leftPanel, decoration } from "./AuthLayout.module.css";
import { CompanyDateFooter } from "./components/CompanyDateFooter";
import { HeaderLogo } from "./components/HeaderLogo";
import { Group, Stack } from "@mantine/core";
import { ColorSchemeControl } from "./components/ColorSchemeControl";
import { LanguagePicker } from "./components/LanguagePicker";
import { API_HOST } from "../constants/url";
import { useMantineColorScheme } from "@mantine/core";
import { Box } from "@mantine/core";

const borderLess = {
  border: "none",
};

const {
  VITE_AUTH_LAYOUT_MAP_TOKEN,
} = import.meta.env;

export const AuthLayout: FC<PropsWithChildren> = ({ children }) => {
  const { colorScheme } = useMantineColorScheme();

  let frameSrc = undefined;
  if (VITE_AUTH_LAYOUT_MAP_TOKEN) {
    frameSrc = colorScheme === "dark"
      ? `https://${API_HOST}/maps/maputnik/osm-liberty?apiKey=${VITE_AUTH_LAYOUT_MAP_TOKEN}`
      : `https://${API_HOST}/maps/maputnik/osm-liberty?apiKey=${VITE_AUTH_LAYOUT_MAP_TOKEN}`;
  }

  return (
    <>
      <Stack className={leftPanel}>
        {colorScheme === "light" && (
          <Box className={decoration} aria-hidden="true" />
        )}
        <Group component="header" justify="space-between">
          <Group gap="xs">
            <HeaderLogo />
          </Group>
          <Group gap="xs">
            <ColorSchemeControl />
            <LanguagePicker />
          </Group>
        </Group>

        <Stack
          component="main"
          mx="auto"
          my="auto"
          w={{ base: 320, sm: 420 }}
        >
          {children}
        </Stack>

        <Stack component="footer" align="center">
          <CompanyDateFooter />
        </Stack>
      </Stack>
      {!frameSrc && (
        <Stack className={rightPanelImg} />
      )}
      {frameSrc && (
        <iframe
          src={frameSrc}
          className={rightPanel}
          style={borderLess}
        />
      )}
    </>
  );
};
